module.exports = __webpack_public_path__ + "media/images/kc_logo_small-043bc9e5211a1a2564e791433d405f4e.png";